module.exports = __webpack_public_path__ + "fonts/Jost-100-Hairline.9fbb736.otf";